<template>
    <v-container fluid fill-height>
        <v-layout justify-center row pa-5>
            <v-flex xs12 sm10 md6>
                <v-card v-for="size_box in size_boxs" :key="size_box.location_id"
                        @click="projectSelect(size_box)"
                        class="my-3"
                        v-if="size_box.qty_available > 0"
                        style="border-left:solid 5px #0045AF;background: #e9eaeb">
                    <v-card-title><b>ขนาด {{ size_box.size_id }}</b> &nbsp;({{ size_box.size_name }})</v-card-title>
                    <v-card-text>ขนาดตู้ {{ size_box.size_dimention_detail }}</v-card-text>
                    <v-card-text style="color: #ff2e34"><b>จำนวนตู้ว่าง {{ size_box.qty_available }} ตู้</b></v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import axios_box24 from '@/axios_box24'
    import EventBus from '@/EventBus'

    export default {
        name: "GetSizeBox24",
        data() {
            return {
                username: this.getLocalItem().user_id,
                size_boxs: [],
                searchText: '',
                api_token: ''
            }
        },
        mounted() {
            window.scrollTo(0, 0)
            EventBus.$emit('set_navigation', {title: 'เลือกขนาดตู้', back_route: 'location-box24'});

            try {
                this.getTokenBox24().then((res) => {
                    this.api_token = res.data.data.api_token
                    this.getSize()
                })
                    .catch(err => {
                        if (err.response) {
                            this.error.status = err.response.data.status;
                            this.error.error_code = err.response.status;
                            if (err.response.status === 401) {
                                this.error.msg = 'ชื่อผู้ใช้งาน หรือ รหัสผ่าน Box24 ไม่ถูกต้อง'
                            } else {
                                this.error.msg = err.response.data.msg
                            }

                            console.log(this.error)
                        }
                    })
            } catch (err2) {
                console.log(err2.message)
            }

            // EventBus.$emit('setNtCode', {nt_code: localItem.NT_CODE});
        },
        methods: {
            async getSize() {
                let bodyFormData = new FormData();
                bodyFormData.set('api_token', this.api_token);
                bodyFormData.set('location_id', this.getLocalItem().box24_location_id);
                bodyFormData.set('country_id', '1');

                try {
                    axios_box24.post('/dropbox24/get-size', bodyFormData)
                        .then(res => {
                            // console.log('getProject', res.data.data)
                            this.size_boxs = res.data.data
                        })
                } catch (err) {
                    console.log(err.message)
                }
            },
            projectSelect(project) {
                if (project) {
                    const localItem = this.getLocalItem()
                    localItem.box24_size_id = project.size_id

                    localStorage.setItem('parcel', JSON.stringify(localItem))
                    this.$router.push('add-order-box24')
                }
            }
        },
    }
</script>

<style scoped>
    .v-card__text {
        padding: 4px 16px 8px;
        font-size: 14px;
    }

    .v-card__title {
        padding: 4px 16px 8px;
        font-size: 22px;
    }

    .v-expansion-panel-content__wrap {
        padding: 0 6px 6px !important;
    }

    .col-9, .col-7, .col-3, .col-2 {
        padding: 0;
    }
</style>